<template lang="pug">
div(v-html="styleTag" ref="root")
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { fontCss } from './custom-bumper-font-styles'

const styleTag = `<style>${fontCss}</style>`

const root = ref<HTMLDivElement | null>(null)

defineExpose({
  $el: root,
})
</script>

